export default __webpack_public_path__ + "static/media/title.91c10478.png";